import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { ClientResourceService } from '../resources/client-resource.service';
import { UserResourceService } from '../resources/user-resource.service';
import { GrowthBookService } from './growthbook/growth-book.service';

@Injectable({
  providedIn: 'root',
})
export class InitialLoadingService {
  private userResourceService = inject(UserResourceService);
  private growthBookService = inject(GrowthBookService);
  private clientResourceService = inject(ClientResourceService);
  private router = inject(Router);

  public isLoadingInitialData = computed(() => {
    return (
      !this.userResourceService.user.hasValue() ||
      !this.clientResourceService.client.hasValue() ||
      !this.growthBookService.isInitialized()
    );
  });

  public waitForInitialization<T>(callback: () => T): Observable<T> {
    return toObservable(this.isLoadingInitialData).pipe(
      filter(isLoading => !isLoading),
      take(1),
      map(() => callback()),
    );
  }

  constructor() {
    this.userResourceService.user
      .load()
      .then(user => {
        if (user && user.clientId) {
          this.clientResourceService.setClientId(user.clientId);
          this.clientResourceService.client.load().catch(() => {
            this.router.navigate(['/error']);
          });
        }
      })
      .catch(() => {
        this.router.navigate(['/error']);
      });
  }
}
